<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text>
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-card-text>

          <div
            v-if="
              userCompany?.isAdmin ||
              userCompany?.isDeveloper ||
              user?.isEngineer
            "
            class="tw-flex tw-mt-4 tw-mx-9 tw-justify-between"
          >
            <span class="tw-font-bold tw-text-xl tw-text-black"
              >การเชื่อมต่อ OpenAI</span
            >
            <div>
              <v-btn
                @click="handleSaveOpenAiKey"
                :disabled="isUpdatingOpenAiKey || isEditPrompt"
                v-if="isEditOpenAiKey"
                class="tw-text-xl tw-mr-4"
                color="success"
                :loading="isUpdatingOpenAiKey"
              >
                {{ "บันทึก" }}
              </v-btn>
              <v-btn
                :disabled="isEditPrompt || isUpdatingOpenAiKey"
                @click="handleEditOpenAiKey"
                v-if="!isEditOpenAiKey"
                class="tw-text-xl tw-mr-4"
                color="warning"
              >
                แก้ไข
              </v-btn>
              <v-btn
                :disabled="isUpdatingOpenAiKey || isEditPrompt"
                @click="handleCancelOpenAiKey"
                v-if="isEditOpenAiKey"
                :class="
                  'tw-text-xl tw-mr-4 ' +
                  (isUpdatingVendor ? 'tw-opacity-50' : '')
                "
                color="error"
              >
                ยกเลิก
              </v-btn>
              <v-btn
                class="tw-text-white"
                color="brown lighten-2"
                @click="showHistoryDialog"
              >
                <v-icon class="mr-2">mdi-history</v-icon>
                ข้อมูลการใช้งานรวม
              </v-btn>
            </div>
          </div>

          <v-row class="tw-px-9 tw-py-4 tw-pt-10">
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                v-if="
                  userCompany?.isAdmin ||
                  userCompany?.isDeveloper ||
                  user?.isEngineer
                "
                v-model="currentSelectedCompany.openAiKey"
                label="OpenAI Key (ใช้งานร่วมกันทุก model และ vendor)"
                :type="showKey ? 'text' : 'password'"
                :readonly="!isEditOpenAiKey"
                outlined
                class="ma-0 pa-0"
                @click:append="toggleShowKey"
                :append-icon="showKey ? 'mdi-eye' : 'mdi-eye-off'"
                persistent-placeholder
                :disabled="isEditPrompt || isTestingOpenAiKey"
              />
            </v-col>
            <v-col
              v-if="
                userCompany?.isAdmin ||
                userCompany?.isDeveloper ||
                user?.isEngineer
              "
              cols="12"
              md="2"
              class="py-0"
            >
              <v-btn
                @click="testOpenAiKey"
                color="info"
                class="tw-h-14 tw-rounded-lg"
                :loading="isTestingOpenAiKey"
                :disabled="!isEditOpenAiKey || isTestingOpenAiKey"
              >
                <v-icon class="tw-mr-2">mdi-access-point</v-icon>
                ทดสอบการเชื่อมต่อ
              </v-btn>
            </v-col>
          </v-row>

          <v-divider class="tw-my-10 tw-mx-9"></v-divider>

          <div class="tw-flex tw-mt-4 tw-mx-9 tw-justify-between">
            <span class="tw-font-bold tw-text-xl tw-text-black"
              >ผู้จำหน่าย</span
            >

            <div
              v-if="
                userCompany?.isAdmin ||
                userCompany?.isDeveloper ||
                user?.isEngineer
              "
            >
              <v-btn
                @click="handleSave"
                :disabled="isUpdatingVendor"
                v-if="isEditPrompt"
                class="tw-text-xl tw-mr-4"
                color="success"
              >
                {{ isUpdatingVendor ? "กำลังบันทึก..." : "บันทึก" }}
              </v-btn>
              <v-btn
                @click="handleEdit"
                :disabled="isEditOpenAiKey"
                v-if="!isEditPrompt"
                class="tw-text-xl tw-mr-4"
                color="warning"
              >
                แก้ไขผู้จำหน่าย
              </v-btn>
              <v-btn
                :disabled="isUpdatingVendor || isEditOpenAiKey"
                @click="handleCancel"
                v-if="isEditPrompt"
                :class="
                  'tw-text-xl tw-mr-4 ' +
                  (isUpdatingVendor ? 'tw-opacity-50' : '')
                "
                color="error"
              >
                ยกเลิก
              </v-btn>
              <v-btn
                :disabled="isUpdatingVendor || isEditOpenAiKey || isEditPrompt"
                @click="handleNewVendorDialogue"
                class="tw-text-xl"
                color="primary"
              >
                <v-icon>mdi-plus</v-icon>
                เพิ่มผู้จำหน่าย
              </v-btn>
            </div>
          </div>

          <div class="com-doc-wrapper tw-py-4 tw-px-2">
            <div
              v-if="selectedCompanyAutoDocConfig.length == 0"
              class="tw-text-center tw-text-lg tw-opacity-50 tw-py-10"
            >
              <v-icon>mdi-alert-circle-outline</v-icon>
              ยังไม่มีข้อมูล
            </div>
            <v-tabs v-model="currentTabIndex">
              <v-row class="tw-px-9">
                <v-tab
                  v-for="(item, index) in selectedCompanyAutoDocConfig"
                  :key="index"
                >
                  {{ item.vendorName }}
                </v-tab>
              </v-row>
              <v-tab-item
                v-for="(item, index) in selectedCompanyAutoDocConfig"
                :key="index"
              >
                <v-card class="tw-pt-4">
                  <v-card-text>
                    <v-row class="ma-0 pb-8">
                      <v-col cols="12" class="py-0">
                        <div class="vendor-avatar">
                          <img
                            :src="
                              currentVendor.logo
                                ? currentVendor.logo
                                : '/images/placeholder.jpg'
                            "
                            class="img-show"
                            :alt="currentVendor.vendorName"
                            ref="vendorLogo"
                          />
                          <v-btn
                            v-if="isEditPrompt"
                            class="btn-upload mt-2"
                            @click="triggerVendorLogoInput"
                            :disabled="loading"
                            >เลือกภาพโลโก้
                          </v-btn>
                          <span v-if="isEditPrompt">ขนาดไม่เกิน 4MB</span>
                        </div>
                        <input
                          v-show="false"
                          ref="vendorLogoInput"
                          type="file"
                          @change="previewVendorLogo"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="ma-0 pa-0">
                      <v-col cols="6" class="py-0">
                        <v-text-field
                          v-model="currentVendor.vendorFullName"
                          persistent-placeholder
                          label="ชื่อเต็ม"
                          class="ma-0 pa-0"
                          :readonly="!isEditPrompt"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" class="py-0">
                        <v-text-field
                          v-model="currentVendor.vendorName"
                          persistent-placeholder
                          label="ชื่อแสดงในเมนู"
                          class="ma-0 pa-0"
                          :readonly="!isEditPrompt"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="ma-0 pa-0">
                      <v-col cols="6" class="py-0">
                        <v-text-field
                          v-model="currentVendor.taxId"
                          persistent-placeholder
                          label="รหัสผู้เสียภาษี"
                          class="ma-0 pa-0"
                          :readonly="!isEditPrompt"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" class="py-0">
                        <v-text-field
                          v-model="currentVendor.vendorCode"
                          persistent-placeholder
                          label="รหัสผู้จำหน่าย"
                          class="ma-0 pa-0"
                          outlined
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="ma-0 pa-0">
                      <v-col cols="2" class="py-0">
                        <v-text-field
                          v-model="currentVendor.ocrCode"
                          label="รหัส OCR"
                          class="ma-0 pa-0"
                          :readonly="!isEditPrompt"
                          persistent-placeholder
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="py-0">
                        <v-text-field
                          v-model="currentVendor.ocrCode2"
                          label="รหัส OCR 2"
                          class="ma-0 pa-0"
                          :readonly="!isEditPrompt"
                          persistent-placeholder
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="py-0">
                        <v-text-field
                          v-model="currentVendor.ocrCode3"
                          label="รหัส OCR 3"
                          class="ma-0 pa-0"
                          :readonly="!isEditPrompt"
                          persistent-placeholder
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="6"
                        v-if="companyID !== 'jmOgyLAiAff6j6vSkJ0n'"
                        class="py-0"
                      >
                        <v-text-field
                          v-model="currentVendor.sqlQuery"
                          type="text"
                          label="SQL Query"
                          class="ma-0 pa-0"
                          :readonly="!isEditPrompt"
                          persistent-placeholder
                          outlined
                          @click:append="
                            () => {
                              if (!isEditPrompt) return;
                              isShowSqlDialog = true;
                            }
                          "
                          append-icon="mdi-fullscreen"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" class="py-0">
                        <v-text-field
                          v-if="companyID === 'jmOgyLAiAff6j6vSkJ0n'"
                          v-model="searchKeywordsDsp"
                          type="text"
                          label="Keywords เพื่อให้ PDF จับ (คั่นด้วย ||)"
                          class="ma-0 pa-0"
                          :readonly="!isEditPrompt"
                          outlined
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row
                      class="ma-0 pa-0"
                      v-if="companyID !== 'jmOgyLAiAff6j6vSkJ0n'"
                    >
                      <v-col cols="6" class="py-0">
                        <v-text-field
                          v-model="searchKeywordsDsp"
                          type="text"
                          label="Keywords เพื่อให้ PDF จับ (คั่นด้วย ||)"
                          class="ma-0 pa-0"
                          :readonly="!isEditPrompt"
                          outlined
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6" class="py-0">
                        <v-text-field
                          v-model="specialSearchKeywordsDsp"
                          type="text"
                          label="Special - Keywords เพื่อให้ PDF จับ (คั่นด้วย ||)"
                          class="ma-0 pa-0"
                          :readonly="!isEditPrompt"
                          outlined
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <div class="tw-px-3 tw-mb-2">
                      <div
                        class="tw-flex tw-items-center tw-justify-between tw-mt-10"
                      >
                        <span
                          class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide tw-mb-2"
                          >ตั้งค่า Text OCR</span
                        >
                      </div>

                      <v-row
                        class="tw-mt-4 tw-mx-4 tw-rounded-lg tw-p-4 model_wrapper"
                      >
                        <v-col cols="12" sm="12">
                          <h4
                            class="tw-text-lg tw-font-bold tw-text-black tw-tracking-wide tw-mb-2"
                          >
                            บริการ OCR
                          </h4>
                          <v-chip-group
                            v-model="currentSelectedOcrService"
                            mandatory
                            active-class="primary"
                            :disabled="!isEditPrompt"
                            :class="{ 'disabled-chip-group': !isEditPrompt }"
                          >
                            <v-chip
                              v-for="service in ocrServiceOptions"
                              :key="service.value"
                              :value="service.value"
                              outlined
                              :color="
                                currentSelectedOcrService === service.value
                                  ? 'primary'
                                  : ''
                              "
                            >
                              <v-icon
                                v-if="
                                  currentSelectedOcrService === service.value
                                "
                                color="primary"
                                >mdi-check</v-icon
                              >
                              <img
                                :src="service.icon"
                                class="tw-w-6 tw-h-6 tw-object-contain tw-mr-2 tw-ml-1"
                              />
                              {{ service.text }}
                            </v-chip>
                          </v-chip-group>
                          <div class="tw-flex tw-items-center tw-mt-2">
                            <div
                              class="tw-w-4 tw-h-4 tw-bg-light-green tw-rounded-full tw-mr-2"
                            ></div>
                            <div
                              class="tw-text-sm tw-text-gray-500-500 tw-flex tw-items-center"
                            >
                              <span>คุณเลือก:</span>
                              <img
                                :src="
                                  currentSelectedOcrService
                                    ? '/images/python.png'
                                    : '/images/google-logo.png'
                                "
                                class="tw-w-6 tw-h-6 tw-object-contain tw-mr-2 tw-ml-1"
                              />
                              <span>{{
                                currentSelectedOcrService
                                  ? "Python"
                                  : "Google Vision"
                              }}</span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>

                      <div
                        class="tw-flex tw-items-center tw-justify-between tw-mt-10"
                      >
                        <span
                          class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide tw-mb-2"
                          >ตั้งค่า Model</span
                        >
                      </div>

                      <v-row
                        class="tw-mt-4 tw-mx-4 tw-rounded-lg tw-p-4 model_wrapper"
                      >
                        <v-col cols="12" sm="12">
                          <h4
                            class="tw-text-lg tw-font-bold tw-text-black tw-tracking-wide tw-mb-2"
                          >
                            Model หลัก
                          </h4>
                          <v-chip-group
                            v-model="primaryModelIndex"
                            mandatory
                            active-class="primary"
                            :disabled="!isEditPrompt"
                            :class="{ 'disabled-chip-group': !isEditPrompt }"
                          >
                            <v-chip
                              v-for="model in modelOptions"
                              :key="model.value"
                              :value="model.value"
                              outlined
                              :color="
                                primaryModelIndex === model.value
                                  ? 'primary'
                                  : ''
                              "
                            >
                              <v-icon
                                v-if="primaryModelIndex === model.value"
                                color="primary"
                                >mdi-check</v-icon
                              >
                              {{ model.text }}
                            </v-chip>
                          </v-chip-group>
                          <div class="tw-flex tw-items-center tw-mt-2">
                            <div
                              class="tw-w-4 tw-h-4 tw-bg-light-green tw-rounded-full tw-mr-2"
                            ></div>
                            <span class="tw-text-sm tw-text-gray-500-500"
                              >คุณเลือก:
                              {{ currentVendor.vendorOpenAiModel1 }}</span
                            >
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <h4
                            class="tw-text-lg tw-font-bold tw-text-black tw-tracking-wide tw-mb-2"
                          >
                            Model สำรอง
                          </h4>
                          <v-chip-group
                            v-model="secondaryModelIndex"
                            mandatory
                            :disabled="!isEditPrompt"
                            active-class="primary"
                            :class="{ 'disabled-chip-group': !isEditPrompt }"
                          >
                            <v-chip
                              v-for="model in modelOptions"
                              :key="model.value"
                              :value="model.value"
                              outlined
                              :color="
                                secondaryModelIndex === model.value
                                  ? 'primary'
                                  : ''
                              "
                            >
                              <v-icon
                                v-if="secondaryModelIndex === model.value"
                                color="primary"
                                >mdi-check</v-icon
                              >
                              {{ model.text }}
                            </v-chip>
                          </v-chip-group>
                          <div class="tw-flex tw-items-center tw-mt-2">
                            <div
                              class="tw-w-4 tw-h-4 tw-bg-light-green tw-rounded-full tw-mr-2"
                            ></div>
                            <span class="tw-text-sm tw-text-gray-500-500"
                              >คุณเลือก:
                              {{ currentVendor.vendorOpenAiModel2 }}</span
                            >
                          </div>
                        </v-col>
                      </v-row>

                      <div
                        class="tw-flex tw-items-center tw-justify-between tw-mt-10"
                      >
                        <span
                          class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide tw-mb-2"
                          >ตั้งค่า Prompt</span
                        >
                      </div>

                      <div class="tw-pt-10">
                        <el-tabs
                          :tab-position="tabPosition"
                          @tab-click="handleTabClick"
                        >
                          <el-tab-pane label="Gpt-4o-mini" class="tw-py-1">
                            <v-col
                              cols="12"
                              class="py-0"
                              v-if="
                                userCompany?.isAdmin ||
                                userCompany?.isDeveloper ||
                                user?.isEngineer
                              "
                            >
                              <v-textarea
                                class="ma-0 pa-0"
                                :value="
                                  currentVendor[
                                    `vendorPrompt${currentVendorModelIndex}`
                                  ]
                                "
                                @input="
                                  updateVendorPrompt(
                                    currentVendorModelIndex,
                                    $event
                                  )
                                "
                                :label="`Prompt - ${
                                  currentVendorModelIndex === 1
                                    ? '4o-mini'
                                    : '4o'
                                }`"
                                :readonly="!isEditPrompt"
                                :rows="textareaRows"
                                outlined
                                persistent-placeholder
                              />
                            </v-col>
                            <v-col cols="12" md="12" class="py-0">
                              <v-checkbox
                                v-model="isApplyAllModel"
                                label="นำไปใช้กับทุก Model"
                                class="ma-0 pa-0"
                              ></v-checkbox>
                            </v-col>
                          </el-tab-pane>
                          <!-- gpt-4o-mini -->
                          <el-tab-pane label="Gpt-4o" class="tw-py-1">
                            <v-col
                              cols="12"
                              class="py-0"
                              v-if="
                                userCompany?.isAdmin ||
                                userCompany?.isDeveloper ||
                                user?.isEngineer
                              "
                            >
                              <v-textarea
                                class="ma-0 pa-0"
                                :value="
                                  currentVendor[
                                    `vendorPrompt${currentVendorModelIndex}`
                                  ]
                                "
                                @input="
                                  updateVendorPrompt(
                                    currentVendorModelIndex,
                                    $event
                                  )
                                "
                                :label="`Prompt - ${
                                  currentVendorModelIndex === 1
                                    ? '4o-mini'
                                    : '4o'
                                }`"
                                :readonly="!isEditPrompt"
                                :rows="textareaRows"
                                outlined
                                persistent-placeholder
                              />
                            </v-col>
                            <v-col cols="12" md="12" class="py-0">
                              <v-checkbox
                                v-model="isApplyAllModel"
                                label="นำไปใช้กับทุก Model"
                                class="ma-0 pa-0"
                              ></v-checkbox>
                            </v-col>
                          </el-tab-pane>
                        </el-tabs>
                      </div>
                    </div>

                    <!-- loop through of branches "-->

                    <!-- delete vendor button -->
                    <div class="tw-flex tw-px-3">
                      <v-btn
                        class="tw-mt-4"
                        color="success"
                        @click="showBranchDialog"
                      >
                        <v-icon class="mr-2">mdi-eye</v-icon>
                        ดูสาขา
                      </v-btn>

                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="
                          userCompany?.isAdmin ||
                          userCompany?.isDeveloper ||
                          user?.isEngineer
                        "
                        class="tw-mt-4"
                        color="error"
                        outlined
                        @click="showDeleteVendorDialog"
                      >
                        <v-icon class="mr-2">mdi-delete</v-icon>
                        ลบผู้จำหน่าย
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </v-card>

        <v-dialog v-model="isShowSqlDialog" max-width="900">
          <v-card>
            <div class="tw-px-8 tw-pt-8">
              <v-textarea
                outlined
                rows="15"
                label="SQL Query"
                :readonly="!isEditPrompt"
                v-if="companyID !== 'jmOgyLAiAff6j6vSkJ0n'"
                v-model="currentVendor.sqlQuery"
                persistent-placeholder
              />
            </div>
          </v-card>
        </v-dialog>

        <!-- DeleteVendorDialog -->
        <v-dialog v-model="isShowDeleteVendorDialog" max-width="500">
          <v-card class="tw-p-4">
            <v-card-title class="tw-pb-0">ลบผู้จำหน่าย</v-card-title>
            <v-card-text class="tw-py-10">
              <div class="tw-text-center tw-text-xl">
                คุณต้องการลบผู้จำหน่าย
                <b>{{ this.currentVendor.vendorName }}</b> ใช่หรือไม่?
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn outlined @click="closeDeleteVendorDialog">ยกเลิก</v-btn>
              <v-btn
                color="error"
                :disabled="isDeletingVendor"
                @click="deleteVendor"
              >
                {{ isDeletingVendor ? "กำลังลบ..." : "ลบ" }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- dialogue  -->
        <v-dialog persistent v-model="isShowNewVendorDialogue" max-width="900">
          <v-card class="tw-p-4">
            <v-card-title class="tw-mb-8">เพิ่มผู้จำหน่าย</v-card-title>
            <v-card-text>
              <v-row class="tw-mb-4">
                <v-col cols="6">
                  <span class="nowrap">
                    รูปภาพโลโก้บริษัท (ขนาดไม่เกิน 4MB)
                  </span>
                  <div
                    class="tw-border-2 tw-cursor-pointer tw-w-40 tw-mt-2 tw-h-40 tw-border-dashed tw-relative tw-rounded tw-flex tw-items-center tw-justify-center"
                    @click="triggerFileInput"
                  >
                    <img
                      v-if="vendor.logo"
                      :src="vendor.logo"
                      alt="Uploaded Image"
                      class="tw-w-full tw-h-full tw-object-cover"
                    />
                    <v-icon v-if="!vendor.logo" size="42">
                      mdi-image-plus-outline
                    </v-icon>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    ref="fileInput"
                    @change="handleFileUpload"
                    style="display: none"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field
                    v-model="vendor.vendorFullName"
                    label="ชื่อเต็ม"
                    outlined
                    required
                    class="pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field
                    v-model="vendor.vendorName"
                    label="ชื่อแสดงในเมนู *"
                    :error="vendorFormErrorMessages.includes('Vendor Name')"
                    outlined
                    required
                    class="pa-0"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field
                    v-model="vendor.vendorCode"
                    label="รหัสผู้จำหน่าย *"
                    :error="vendorFormErrorMessages.includes('Vendor Code')"
                    outlined
                    required
                    class="pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field
                    v-model="vendor.taxId"
                    label="เลขประจำตัวผู้เสียภาษี"
                    outlined
                    class="pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field
                    v-model="vendor.ocrCode"
                    label="รหัส OCR"
                    outlined
                    class="pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field
                    v-model="vendor.ocrCode2"
                    label="รหัส OCR 2"
                    outlined
                    class="pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field
                    v-model="vendor.ocrCode3"
                    label="รหัส OCR 3"
                    outlined
                    class="pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="vendor.searchKeywords"
                    label="Keywords เพื่อให้ PDF จับ (คั่นด้วย ||)"
                    outlined
                    class="pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-if="companyID !== 'jmOgyLAiAff6j6vSkJ0n'"
                    v-model="vendor.specialSearchKeywords"
                    label="Special - Keywords เพื่อให้ PDF จับ (คั่นด้วย ||)"
                    outlined
                    class="pa-0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <span class="tw-text-red-500">{{ vendorFormErrorMessages }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="closeNewVendorDialogue" color="error">
                ยกเลิก
              </v-btn>
              <v-btn
                :disabled="isSavingVendor"
                @click="handleCreateNewVendorDialogue"
                color="primary"
              >
                {{ isSavingVendor ? "กำลังบันทึก..." : "บันทึก" }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Branch Dialog -->
        <v-dialog v-model="isShowBranchDialog" max-width="1000">
          <v-card class="tw-p-4">
            <div
              class="tw-pb-4 tw-my-4 tw-text-center tw-border-b tw-border-gray-500 tw-mx-4 tw-font-bold"
            >
              {{ currentVendor?.vendorName }} - สาขาทังหมด (
              {{ currentVendor?.branches?.length || 0 }} )
            </div>
            <v-btn
              color="error"
              :disabled="isDeletingBranches || !currentVendorBranches?.length"
              class="tw-mx-4"
              @click="deleteAllBranches"
            >
              <v-icon left>mdi-delete-sweep</v-icon>
              ลบทั้งหมด
            </v-btn>
            <div class="tw-mx-4 tw-mt-4 tw-overflow-y-scroll tw-max-h-132">
              <v-data-table
                class="nowrap"
                hide-default-footer
                :items-per-page="-1"
                :headers="[
                  { text: 'ดำเนินการ', value: 'actions' },
                  { text: 'ชื่อสาขา', value: 'branchName' },
                  { text: 'รหัสสาขา', value: 'branch' },
                  { text: 'อําเภอ', value: 'district' },
                  { text: 'ตำบล', value: 'subDistrict' },
                  { text: 'จังหวัด', value: 'province' },
                  { text: 'บ้านเลขที่', value: 'street' },
                  { text: 'รหัสไปรษณีย์', value: 'zipCode' },
                ]"
                :items="currentVendorBranches"
                item-key="branchName"
              >
                <template v-slot:body="{ items, headers }">
                  <tbody>
                    <tr v-for="(item, idx) in items" :key="idx">
                      <td v-for="(header, key) in headers" :key="key">
                        <v-btn
                          v-if="header.value === 'actions'"
                          color="error"
                          icon
                          @click="openDeleteBranchDialog(idx)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <template v-else>
                          <v-edit-dialog
                            v-if="isEditVendorBranch"
                            @save="saveEditVendorBranch"
                            @cancel="cancelEditDialogue"
                            save-text="บันทึก"
                            cancel-text="ยกเลิก"
                            large
                          >
                            {{ item[header.value] }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="item[header.value]"
                                label="Edit"
                                single-line
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                          <span v-else class="tw-cursor-default">
                            {{ item[header.value] }}
                          </span>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </div>
            <div
              class="tw-py-4 tw-mx-4 tw-flex tw-mt-4 tw-border-t tw-border-gray-500"
            >
              <v-btn outlined @click="isShowBranchDialog = false">ปิด</v-btn>
              <input
                type="file"
                accept=".csv"
                ref="csvInput"
                style="display: none"
                @change="handleCsvUpload"
              />
              <v-btn
                color="primary"
                class="tw-ml-4"
                :disabled="isDeletingBranches"
                @click="triggerCsvInput"
              >
                <v-icon left>mdi-file-import</v-icon>
                นำเข้าจาก CSV
              </v-btn>
              <v-btn
                color="blue"
                class="tw-ml-2"
                outlined
                :disabled="isDeletingBranches || !currentVendorBranches?.length"
                @click="exportCsv"
              >
                <v-icon left>mdi-file-export</v-icon>
                ส่งออก CSV
              </v-btn>

              <v-spacer></v-spacer>
              <v-btn
                :disabled="isDeletingBranches || !currentVendorBranches?.length"
                :color="isEditVendorBranch ? 'error' : 'warning'"
                class="tw-mr-4"
                @click="isEditVendorBranch = !isEditVendorBranch"
              >
                {{ isEditVendorBranch ? "ยกเลิก" : "แก้ไข" }}
              </v-btn>
              <v-btn color="primary" @click="isShowAddBranchDialog = true">
                <v-icon left>mdi-plus</v-icon>
                เพิ่มสาขา
              </v-btn>
            </div>
          </v-card>
        </v-dialog>

        <!-- Add Branch Dialog -->
        <v-dialog
          v-model="isShowAddBranchDialog"
          transition="dialog-bottom-transition"
          max-width="600"
        >
          <v-card class="tw-py-6 tw-px-8">
            <p class="tw-font-bold">เพิ่มสาขา</p>
            <v-text-field
              label="ชื่อสาขา"
              v-model="addBranchData.branchName"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="รหัสสาขา"
              v-model="addBranchData.branch"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="อําเภอ"
              v-model="addBranchData.district"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="ตำบล"
              v-model="addBranchData.subDistrict"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="จังหวัด"
              v-model="addBranchData.province"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="บ้านเลขที่"
              v-model="addBranchData.street"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="รหัสไปรษณีย์"
              v-model="addBranchData.zipCode"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="shipTo"
              v-model="addBranchData.shipTo"
              outlined
              dense
            ></v-text-field>
            <div class="tw-flex tw-justify-between">
              <v-btn
                @click="isShowAddBranchDialog = false"
                outlined
                :disabled="isAddingBranch"
                >ยกเลิก</v-btn
              >
              <v-btn
                color="primary"
                @click="addNewVendorBranch"
                :disabled="!isAddable || isAddingBranch"
                outlined
                >{{ isAddingBranch ? "กำลังเพิ่ม" : "เพิ่ม" }}</v-btn
              >
            </div>
          </v-card>
        </v-dialog>
        <!-- Delete Branch Dialog -->
        <v-dialog v-model="isShowDeleteBranchDialog" max-width="500">
          <v-card class="tw-p-4">
            <v-card-title class="tw-pb-0">ลบสาขา</v-card-title>
            <v-card-text class="tw-py-10">
              <div class="tw-text-center tw-text-xl">
                คุณต้องการลบสาขา
                <b>{{ this.deleteBranchData.branchName }}</b> ใช่หรือไม่?
              </div>
            </v-card-text>
            <v-card-actions class="tw-flex tw-justify-between">
              <v-btn outlined @click="isShowDeleteBranchDialog = false"
                >ยกเลิก</v-btn
              >
              <v-btn color="error" @click="deleteVendorBranch"> ลบ </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- History Dialog -->
        <v-dialog v-model="isShowHistoryDialog" max-width="1300">
          <v-card class="tw-p-4" style="height: auto">
            <div
              class="tw-pb-4 tw-my-4 tw-text-center tw-border-b tw-border-gray-500 tw-mx-4 tw-font-bold"
            >
              ข้อมูลการใช้งานรวม
            </div>
            <div
              class="tw-mx-4 tw-mt-4 tw-max-h-132 tw-flex tw-justify-between"
            >
              <!-- <v-spacer></v-spacer> -->
              <v-select
                :menu-props="{ bottom: true, offsetY: true }"
                v-model="selectedMonth"
                :items="selectedChatGptActivityLog"
                item-value="id"
                item-text="id"
                label="Select Month"
              ></v-select>
            </div>
            <div
              class="tw-mx-4 tw-mt-4 tw-overflow-y-scroll tw-max-h-132 tw-h-146"
            >
              <v-data-table
                class="nowrap"
                hide-default-footer
                :items-per-page="-1"
                :headers="[
                  { text: 'Date', value: 'id' },
                  { text: 'PDF File', value: 'countDetails' },
                  { text: 'Input Tokens', value: 'tokenPrompt' },
                  { text: 'Output Tokens', value: 'tokenCompletion' },
                  { text: 'Total Tokens', value: 'tokenTotal' },
                ]"
                :loading="loading"
                loading-text="Loading... Please wait"
                :items="formatNumbers(selectedDateChatGptActivityLog)"
                item-key="id"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                show-expand
              >
                <!-- <template v-slot:expanded-item="{  }">
                <td :colspan="6" class="expanded-item-td">
                  <v-data-table
                  hide-default-footer
                  dense
                  class="elevation-1"
                    :headers="[
                      { text: 'Model Version', value: 'modelVersion', class: 'my-header-style' },
                      { text: 'PDF File', value: 'pdfFile', class: 'my-header-style' },
                      { text: 'Input Tokens', value: 'tokenPrompt', class: 'my-header-style' },
                      { text: 'Output Tokens', value: 'tokenCompletion', class: 'my-header-style' },
                      { text: 'Total Tokens', value: 'tokenTotal', class: 'my-header-style' },
                    ]"
                    :items="groupByModelVersion(selectedDateDetailChatGptActivityLog)"
                    item-key="id"
                    full-width
                    :item-class="rowClass"
                  ></v-data-table>
                </td>
              </template> -->
                <template v-slot:expanded-item="{ item }">
                  <td :colspan="6" class="expanded-item-td">
                    <v-data-table
                      hide-default-footer
                      dense
                      class="elevation-1"
                      :headers="[
                        {
                          text: 'Model Version',
                          value: 'modelVersion',
                          class: 'my-header-style',
                        },
                        {
                          text: 'PDF File',
                          value: 'countDetails',
                          class: 'my-header-style',
                        },
                        {
                          text: 'Input Tokens',
                          value: 'tokenPrompt',
                          class: 'my-header-style',
                        },
                        {
                          text: 'Output Tokens',
                          value: 'tokenCompletion',
                          class: 'my-header-style',
                        },
                        {
                          text: 'Total Tokens',
                          value: 'tokenTotal',
                          class: 'my-header-style',
                        },
                      ]"
                      :items="formatNumbers(item.modelData)"
                      item-key="modelVersion"
                      full-width
                      :item-class="rowClass"
                    ></v-data-table>
                  </td>
                </template>
              </v-data-table>
            </div>
            <div class="tw-mx-4 tw-mt-4 tw-border-t tw-py-4">
              <v-row
                justify="end"
                v-for="model in modelData"
                :key="model.modelVersion"
                class="pa-0 ma-0"
              >
                <v-col cols="12" sm="6" md="4" class="tw-py-0">
                  <v-text-field
                    label="Model"
                    readonly
                    :value="model?.modelVersion"
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Total PDFs"
                    readonly
                    :value="model.countDetails?.toLocaleString()"
                    reverse
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Total Inputs"
                    readonly
                    :value="model.tokenPrompt?.toLocaleString()"
                    reverse
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Total Outputs"
                    readonly
                    :value="model.tokenCompletion?.toLocaleString()"
                    reverse
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Net Tokens"
                    readonly
                    :value="model.tokenTotal?.toLocaleString()"
                    class="text-right"
                    outlined
                    reverse
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <div class="tw-py-4 tw-mx-4 tw-flex tw-mt-2 tw-border-gray-500">
              <v-btn outlined @click="isShowHistoryDialog = false">ปิด</v-btn>
            </div>
          </v-card>
        </v-dialog>

        <v-snackbar
          timeout="2500"
          v-model="snackbarOpenAiKey"
          color="success"
          top
        >
          ทดสอบการเชื่อมต่อสำเร็จ
        </v-snackbar>
        <v-snackbar
          timeout="2500"
          v-model="snackbarOpenAiKeyError"
          color="error"
          top
        >
          ทดสอบการเชื่อมต่อไม่สำเร็จ
        </v-snackbar>
        <v-snackbar timeout="2500" v-model="snackbar" color="success" top>
          บันทึกข้อมูลสำเร็จ
        </v-snackbar>
        <v-snackbar
          timeout="2500"
          v-model="snackbarSaveError"
          color="error"
          top
        >
          เกิดข้อผิดพลาด บันทึกข้อมูลไม่สำเร็จ
        </v-snackbar>
        <v-snackbar timeout="2500" v-model="snackbarDelete" color="success" top>
          ลบข้อมูลสำเร็จ
        </v-snackbar>
        <v-snackbar
          timeout="2500"
          v-model="snackbarImageTooLarge"
          color="error"
          top
        >
          โลโก้มีขนาดใหญ่เกินไป
        </v-snackbar>
        <v-snackbar
          timeout="2500"
          v-model="snackbarImageTooSmall"
          color="error"
          top
        >
          โลโก้มีขนาดเล็กกว่า 50px
        </v-snackbar>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import { mapState } from "vuex";
import _isEqual from "lodash/isEqual";
import fc from "@/firebaseConfig";
import axios from "axios";

import { uploadToCurrentUserCompanyBucket } from "@/libs/imageUploader";
import { checkImageSmall } from "@/libs/validateImageUpload";

const gptModels = ["gpt-4o-mini", "gpt-4o"];
// const gptModels = ["gpt-3.5-turbo-1106", "gpt-4o"];

export default {
  name: "Settings",
  components: {
    Admin,
  },
  data: () => ({
    modelOptions: [
      { text: "GPT-4o", value: "gpt-4o" },
      { text: "GPT-4o Mini", value: "gpt-4o-mini" },
    ],
    primaryModelIndex: null,
    secondaryModelIndex: null,
    tabPosition: "left",
    snackbarOpenAiKey: false,
    snackbarOpenAiKeyError: false,
    isTestingOpenAiKey: false,
    isUpdatingOpenAiKey: false,
    isDeletingBranches: false,
    isApplyAllModel: false,
    showKey: false,
    isShowSqlDialog: false,
    isEditVendorBranch: false,
    snackbar: false,
    snackbarDelete: false,
    snackbarSaveError: false,
    snackbarImageTooLarge: false,
    snackbarImageTooSmall: false,
    isShowDeleteVendorDialog: false,
    isDeletingVendor: false,
    isSavingVendor: false,
    isShowBranchDialog: false,
    isShowHistoryDialog: false,
    isShowAddBranchDialog: false,
    isShowDeleteBranchDialog: false,
    singleExpand: true,
    currentVendorModelIndex: 1,
    currentVendorModelTab: 0,
    items: [
      {
        text: "ตั้งค่า",
        disabled: false,
        to: { name: "Company.Settings" },
      },
      {
        text: "เอกสารอัตโนมัติ",
        disabled: true,
      },
    ],
    alignments: ["end"],
    isUpdatingVendor: false,
    isEditPrompt: false,
    isEditOpenAiKey: false,
    currentTabIndex: 0,
    currentVendor: {},
    currentVendorBranches: [],
    isAddingBranch: false,
    addBranchData: {
      branchName: "",
      branch: "",
      district: "",
      subDistrict: "",
      province: "",
      street: "",
      zipCode: "",
      shipTo: "",
    },
    deleteBranchData: {},
    currentVendorCopy: {},
    historyDate: {},
    historyDateDetails: {},
    modelData: [],
    expanded: [],
    currentSelectedCompany: {},
    currentSelectedCompanyCopy: {},
    selectedCompanyBlank: {
      openAiKey: "",
    },
    vendorBlank: {
      vendorName: "",
      vendorFullName: "",
      vendorCode: "",
      taxId: "",
      ocrCode: "",
      ocrCode2: "",
      ocrCode3: "",
      searchKeywords: "",
      sqlQuery: "",
      specialSearchKeywords: "",
      vendorOpenAiModel1: gptModels[0],
      vendorOpenAiModel2: gptModels[1],
      vendorPrompt1: "",
      vendorPrompt2: "",
      logo: "",
      isActive: true,
      isPython: false,
    },
    vendor: {
      vendorName: "",
      vendorFullName: "",
      vendorCode: "",
      taxId: "",
      ocrCode: "",
      ocrCode2: "",
      ocrCode3: "",
      searchKeywords: "",
      specialSearchKeywords: "",
      sqlQuery: "",
      vendorOpenAiModel1: gptModels[0],
      vendorOpenAiModel2: gptModels[1],
      vendorPrompt1: "",
      vendorPrompt2: "",
      logo: "",
      isActive: true,
      isPython: false,
    },
    isVendorFormError: false,
    searchKeywordsDsp: "",
    specialSearchKeywordsDsp: "",
    selectedMonth: "",
    vendorFormErrorMessages: "",
    isShowNewVendorDialogue: false,
    gptModelOptions: [
      { text: gptModels[0], value: gptModels[0] },
      { text: gptModels[1], value: gptModels[1] },
    ],
    currentSelectedModel: gptModels[0],
    ocrServiceOptions: [
      { text: "Google Vision", value: false, icon: "/images/google-logo.png" },
      { text: "Python", value: true, icon: "/images/python.png" },
    ],
    currentSelectedOcrService: false,
    companyID: "",
  }),
  computed: {
    ...mapState({
      selectedCompany: (state) => state.companies.selectedCompany,
      selectedCompanyAutoDocConfig: (state) =>
        state.companies.selectedCompanyAutoDocConfig,
      user: (state) => state.user.userData,
      loading: (state) => state.companies.loading,
      userCompany: (state) => state.user.userCompany,
      selectedChatGptActivityLog: (state) =>
        state.companies.selectedChatGptActivityLog,
      selectedDateChatGptActivityLog: (state) =>
        state.companies.selectedDateChatGptActivityLog,
      selectedDateDetailChatGptActivityLog: (state) =>
        state.companies.selectedDateDetailChatGptActivityLog,
    }),
    textareaRows() {
      // Determine number of rows based on screen size
      return this.$vuetify.breakpoint.lg ? 20 : 15;
    },
    isAddable() {
      const isBranchExisted = this.currentVendorBranches.find(
        (branch) => branch.branch === this.addBranchData.branch
      );
      return this.mustNotContainBlank(this.addBranchData) && !isBranchExisted;
    },
  },
  created() {
    this.companyID = this.$route.params.companyId;
    if (this.companyID) {
      this.$store.dispatch("user/getRoleUser", { companyId: this.companyID });
    }

    this.getChatGptActivityLog();
    this.selectedMonth = this.getCurrentMonth();
  },
  methods: {
    handleTabClick(tab) {
      console.log(Number(tab.index) + 1);
      this.currentVendorModelIndex = Number(tab.index) + 1;
    },
    async testOpenAiKey() {
      this.isTestingOpenAiKey = true;
      try {
        const response = await fetch("https://api.openai.com/v1/models", {
          headers: {
            Authorization: `Bearer ${this.currentSelectedCompany.openAiKey}`,
          },
        });
        if (response.ok) {
          this.snackbarOpenAiKey = true;
        } else {
          throw new Error("Connection failed");
        }
      } catch (error) {
        console.error(error);
        this.snackbarOpenAiKeyError = true;
      } finally {
        this.isTestingOpenAiKey = false;
      }
    },
    async deleteAllBranches() {
      // Nothing to delete?
      if (!this.currentVendorBranches.length) {
        this.snackbarSaveError = true;
        return;
      }
      // Confirm with the user
      if (!confirm("คุณต้องการลบสาขาทั้งหมดใช่หรือไม่?")) {
        return;
      }

      this.isDeletingBranches = true;
      try {
        // Clear local array
        this.currentVendorBranches = [];
        // Update Firestore
        const companyID = this.companyID;
        const vendorCode = this.currentVendor.vendorCode;
        const vendorRef = fc.db.doc(
          `Companies/${companyID}/PurchaseOrderSettings/${vendorCode}`
        );
        await vendorRef.update({ branches: [] });

        // Show success and close dialog
        this.snackbarDelete = true;
        this.isShowBranchDialog = false;
      } catch (error) {
        console.error(error);
        this.snackbarSaveError = true;
      } finally {
        this.isDeletingBranches = false;
      }
    },
    exportCsv() {
      if (!this.currentVendorBranches.length) {
        this.snackbarSaveError = true; // or show a dedicated warning
        return;
      }

      // 1. Define CSV headers (in the order your table expects)
      const headers = [
        "branch",
        "branchName",
        "district",
        "province",
        "shipTo",
        "street",
        "subDistrict",
        "zipCode",
      ];

      // 2. Build CSV content
      const rows = this.currentVendorBranches.map((branch) =>
        headers
          .map((h) => `"${(branch[h] || "").replace(/"/g, '""')}"`)
          .join(",")
      );
      const csvContent = [headers.join(","), ...rows].join("\r\n");

      // 3. Create downloadable blob & click an <a>
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      // filename: vendorCode_branches_YYYYMMDD.csv
      const date = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      link.setAttribute(
        "download",
        `${this.currentVendor.vendorCode}_branches_${date}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    triggerCsvInput() {
      this.$refs.csvInput.click();
    },
    handleCsvUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = async (e) => {
        // 1. Parse CSV text
        const text = e.target.result;
        const lines = text.trim().split(/\r?\n/);
        const [headerLine, ...rows] = lines;
        const headers = headerLine.split(",").map((h) => h.trim());

        // 2. Map rows into objects
        const imported = rows.map((line) => {
          const cols = line.split(",");
          const obj = {};
          headers.forEach((h, i) => {
            obj[h] = cols[i] ? cols[i].trim() : "";
          });
          return {
            branch: obj.branch?.replace(/"/g, ""),
            branchName: obj.branchName?.replace(/"/g, ""),
            district: obj.district?.replace(/"/g, ""),
            subDistrict: obj.subDistrict?.replace(/"/g, ""),
            province: obj.province?.replace(/"/g, ""),
            shipTo: obj.shipTo?.replace(/"/g, ""),
            street: obj.street?.replace(/"/g, ""),
            zipCode: obj.zipCode?.replace(/"/g, ""),
          };
        });

        // 3. Replace local branches and save to Firestore
        this.currentVendorBranches = imported;
        try {
          const companyID = this.companyID;
          const vendorCode = this.currentVendor.vendorCode;
          const vendorRef = fc.db.doc(
            `Companies/${companyID}/PurchaseOrderSettings/${vendorCode}`
          );
          await vendorRef.update({ branches: this.currentVendorBranches });
          this.snackbar = true; // show success snackbar
        } catch (err) {
          console.error(err);
          this.snackbarSaveError = true;
        }
      };
      reader.readAsText(file, "UTF-8");
    },
    toggleShowKey() {
      this.showKey = !this.showKey;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      // console.log("file:: ", file);
      if (this.isImageTooLarge(file)) {
        this.snackbarImageTooLarge = true;
        return;
      }
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.vendor.logo = URL.createObjectURL(event.target.files[0]);
          console.log("this.vendor.logo:: ", this.vendor.logo);
        };
        reader.readAsDataURL(file);
      }
    },
    updateVendorModel(value) {
      switch (value) {
        case gptModels[0]:
          this.currentVendorModelIndex = 1;
          break;
        case gptModels[1]:
          this.currentVendorModelIndex = 2;
          break;
        default:
          break;
      }
    },
    updateVendorPrompt(index, value) {
      if (this.isApplyAllModel) {
        this.$set(this.currentVendor, `vendorPrompt${index}`, value);
        this.$set(
          this.currentVendor,
          `vendorPrompt${index === 1 ? 2 : 1}`,
          value
        );
      } else {
        this.$set(this.currentVendor, `vendorPrompt${index}`, value);
      }
    },
    closeEditDialogue() {
      console.log("closeEditDialogue");
    },
    openEditDialogue() {
      console.log("openEditDialogue");
    },
    cancelEditDialogue() {
      console.log("cancelEditDialogue");
    },
    async saveEditVendorBranch() {
      // EditVendorBranch
      const companyID = this.$route.params.companyId;
      const vendorID = this.currentVendor.vendorCode;
      const vendorRef = fc.companies.doc(
        `${companyID}/PurchaseOrderSettings/${vendorID}`
      );
      const vendorDoc = await vendorRef.get();
      if (vendorDoc.exists) {
        vendorRef.update({
          branches: this.currentVendorBranches,
        });
        this.snackbar = true;
      } else {
        this.snackbarSaveError = true;
      }
    },
    findModelData(month) {
      const selectedData = this.selectedChatGptActivityLog.find(
        (item) => item.id === this.selectedMonth
      );
      return selectedData ? selectedData.modelData : [];
    },
    closeNewVendorDialogue() {
      this.vendor = Object.assign({}, this.vendorBlank);
      this.isVendorFormError = false;
      this.vendorFormErrorMessages = "";
      this.isShowNewVendorDialogue = false;
    },
    showDeleteVendorDialog() {
      this.isShowDeleteVendorDialog = true;
    },
    showBranchDialog() {
      this.isShowBranchDialog = true;
    },
    showHistoryDialog() {
      this.isShowHistoryDialog = true;
    },
    closeDeleteVendorDialog() {
      this.isShowDeleteVendorDialog = false;
    },
    firestoreTimestampToDate(timestamp) {
      if (
        timestamp &&
        typeof timestamp.seconds === "number" &&
        typeof timestamp.nanoseconds === "number"
      ) {
        return new Date(
          timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000
        );
      }
      return null;
    },
    groupByModelVersion(data) {
      const groupedData = {};

      data.forEach((item, index) => {
        const modelVersion = item.modelVersion;
        const docID = item.id;

        if (!groupedData[modelVersion]) {
          groupedData[modelVersion] = {
            id: docID,
            modelVersion: modelVersion,
            tokenCompletion: 0,
            tokenPrompt: 0,
            tokenTotal: 0,
            pdfFile: 0,
            index: index,
          };
        }

        groupedData[modelVersion].tokenCompletion += item.tokenCompletion;
        groupedData[modelVersion].tokenPrompt += item.tokenPrompt;
        groupedData[modelVersion].tokenTotal += item.tokenTotal;
        groupedData[modelVersion].pdfFile++;
      });

      Object.values(groupedData).forEach((item) => {
        item.tokenCompletion = item.tokenCompletion.toLocaleString();
        item.tokenPrompt = item.tokenPrompt.toLocaleString();
        item.tokenTotal = item.tokenTotal.toLocaleString();
        item.pdfFile = item.pdfFile.toLocaleString();
      });

      return Object.values(groupedData);
    },
    async deleteVendor() {
      this.isDeletingVendor = true;
      try {
        const companyID = this.$route.params.companyId;
        const vendorRef = fc.db.doc(
          `Companies/${companyID}/PurchaseOrderSettings/${this.currentVendor.vendorCode}`
        );
        // await vendorRef.delete();
        await vendorRef.set(
          {
            isActive: false,
          },
          { merge: true }
        );
        this.$store.dispatch("companies/getCompanyAutoDocConfig", {
          companyId: companyID,
        });
        // await this.deleteVendorLogos(
        //   fc.auth.currentUser.uid,
        //   companyID,
        //   this.currentVendor.vendorCode
        // );
        this.snackbarDelete = true;
        this.isShowDeleteVendorDialog = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.isDeletingVendor = false;
      }
    },
    async handleCreateNewVendorDialogue() {
      // Validate vendorName and vendorCode
      if (this.vendor.vendorName === "") {
        this.isVendorFormError = true;
        this.vendorFormErrorMessages = "Vendor Name ยังไม่ได้ระบุ";
        return;
      }
      if (this.vendor.vendorCode === "") {
        this.isVendorFormError = true;
        this.vendorFormErrorMessages = "Vendor Code ยังไม่ได้ระบุ";
        return;
      }
      if (this.vendor.vendorCode.includes(" ")) {
        this.isVendorFormError = true;
        this.vendorFormErrorMessages = "Vendor Code ห้ามมีช่องว่าง";
        return;
      }

      // Check if vendorCode already exists
      let isVendorCodeExist = false;
      const companyID = this.$route.params.companyId;
      const vendorRef = fc.db.doc(
        `Companies/${companyID}/PurchaseOrderSettings/${this.vendor.vendorCode}`
      );

      await vendorRef.get().then((doc) => {
        if (doc.exists) {
          isVendorCodeExist = true;
        }
      });

      if (isVendorCodeExist) {
        this.isVendorFormError = true;
        this.vendorFormErrorMessages = "Vendor Code มีในระบบแล้ว";
        return;
      }

      this.isVendorFormError = false;
      this.vendorFormErrorMessages = "";

      this.isSavingVendor = true;
      try {
        const file = this.$refs?.fileInput?.files[0];
        if (file) {
          this.vendor.logo = await this.uploadVendorLogo(
            file,
            this.vendor.vendorCode
          );
        }

        await vendorRef.set({
          ...this.vendor,
          searchKeywords:
            this.vendor.searchKeywords
              .split("||")
              .map((keyword) => keyword.trim())
              .filter((keyword) => keyword !== "") || [],
          specialSearchKeywords:
            this.vendor.specialSearchKeywords
              .split("||")
              .map((keyword) => keyword.trim())
              .filter((keyword) => keyword !== "") || [],
          isPython: this.vendor.isPython ?? false, // Explicitly include isPython
        });

        this.$store.dispatch("companies/getCompanyAutoDocConfig", {
          companyId: companyID,
        });
        this.vendor = Object.assign({}, this.vendorBlank);

        this.snackbar = true;
        this.isShowNewVendorDialogue = false;
        this.closeNewVendorDialogue();
      } catch (error) {
        console.error(error);
        this.snackbarSaveError = true;
      } finally {
        this.isSavingVendor = false;
      }
    },
    handleNewVendorDialogue() {
      this.isShowNewVendorDialogue = true;
    },
    handleEdit() {
      this.isEditPrompt = true;
    },
    rowClass() {
      return "row_Class";
    },
    getCurrentMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const formattedMonth = month < 10 ? `0${month}` : `${month}`;
      return `${year}-${formattedMonth}`;
    },
    getCompanyAutoDocConfig() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getCompanyAutoDocConfig", { companyId });
    },
    getChatGptActivityLog() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getChatGptActivityLog", { companyId });
    },
    getSelectedCompany() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/setCompany", { companyId });
    },
    fetchDateData() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getDateListChatGptActivityLog", {
        companyId,
        newVal: this.selectedMonth,
      });
    },
    sumColumn(columnName) {
      return this.selectedDateChatGptActivityLog.reduce(
        (total, item) => total + item[columnName],
        0
      );
    },
    formatNumbers(data) {
      return data.map((item) => ({
        ...item,
        countDetails: item.countDetails.toLocaleString(),
        tokenPrompt: item.tokenPrompt.toLocaleString(),
        tokenCompletion: item.tokenCompletion.toLocaleString(),
        tokenTotal: item.tokenTotal.toLocaleString(),
      }));
    },
    onRowClick(item) {
      // Check if the row is being expanded or collapsed
      const isExpanded = this.expanded.includes(item.id);
      if (isExpanded) {
        // Perform an action when the row is expanded
        console.log("Row expanded:", item);
        // Example action: fetch additional details for the expanded row
        this.fetchRowDetails(item);
      } else {
        console.log("Row collapsed:", item);
      }
    },
    handleEditOpenAiKey() {
      this.isEditOpenAiKey = true;
    },
    handleCancelOpenAiKey() {
      this.isEditOpenAiKey = false;
    },
    async handleSaveOpenAiKey() {
      this.isUpdatingOpenAiKey = true;
      try {
        const companyID = this.$route.params.companyId;
        const companyRef = fc.db.doc(`Companies/${companyID}`);
        await companyRef.update({
          openAiKey: this.currentSelectedCompany.openAiKey?.trim(),
        });
        this.getSelectedCompany();
        this.snackbar = true;
        console.log("Update Company Successful");

        this.isEditOpenAiKey = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.isUpdatingOpenAiKey = false;
      }
    },
    async handleSave() {
      this.isUpdatingVendor = true;
      try {
        const companyID = this.$route.params.companyId;
        const vendorRef = fc.db.doc(
          `Companies/${companyID}/PurchaseOrderSettings/${this.currentVendor.vendorCode}`
        );

        const formatArrSearchKeywords =
          typeof this.currentVendor?.searchKeywords === "string"
            ? this.currentVendor?.searchKeywords
                .split("||")
                .map((keyword) => keyword.trim())
                .filter((keyword) => keyword !== "")
            : this.currentVendor?.searchKeywords || [];

        const formatArrSpecialSearchKeywords =
          typeof this.currentVendor?.specialSearchKeywords === "string"
            ? this.currentVendor?.specialSearchKeywords
                .split("||")
                .map((keyword) => keyword.trim())
                .filter((keyword) => keyword !== "")
            : this.currentVendor?.specialSearchKeywords || [];

        const updateData = {
          ...this.currentVendor,
          searchKeywords: formatArrSearchKeywords,
          specialSearchKeywords: formatArrSpecialSearchKeywords,
          isPython: this.currentVendor.isPython ?? false, // Explicitly include isPython
        };

        await vendorRef.update(updateData);
        await this.updateVendorLogo(vendorRef);
        this.getCompanyAutoDocConfig();
        console.log("Update Vendor Successful");

        this.snackbar = true;
        this.isEditPrompt = false;
      } catch (error) {
        console.error(error);
        this.snackbarSaveError = true;
      } finally {
        this.isEditPrompt = false;
        this.isUpdatingVendor = false;
      }
    },
    handleCancel() {
      // Add your cancel logic here
      this.currentVendor = Object.assign({}, this.currentVendorCopy);
      this.currentSelectedCompany = Object.assign(
        {},
        this.currentSelectedCompanyCopy
      );
      this.isEditPrompt = false;
    },
    triggerVendorLogoInput() {
      this.$refs.vendorLogoInput[0].click();
    },
    async previewVendorLogo() {
      const file = this.$refs.vendorLogoInput[0].files[0];
      if (!file) return;
      if (this.isImageTooLarge(file)) {
        this.snackbarImageTooLarge = true;
        return;
      }
      const isTooSmall = await checkImageSmall(file, 50);
      if (isTooSmall) {
        // alert("width lower 50 pixels. please select new image.");
        this.snackbarImageTooSmall = true;
        return;
      }
      this.currentVendor.logo = URL.createObjectURL(file);
    },
    async updateVendorLogo(vendorRef) {
      try {
        let file = this.$refs?.vendorLogoInput[0]?.files[0];
        if (!file) return;
        if (this.isImageTooLarge(file)) {
          this.snackbarImageTooLarge = true;
          return;
        }
        const isTooSmall = await checkImageSmall(file, 50);
        if (isTooSmall) {
          // alert("width lower 50 pixels. please select new image.");
          this.snackbarImageTooSmall = true;
          return;
        }
        const companyID = this.$route.params.companyId;
        const userID = fc.auth.currentUser.uid;
        //
        await this.deleteVendorLogos(
          userID,
          companyID,
          this.currentVendor.vendorCode
        );
        //
        const uploadLogo = await uploadToCurrentUserCompanyBucket(
          file,
          companyID,
          `Logo/${this.currentVendor.vendorCode}`
        );
        const vendorRef = fc.db.doc(
          `Companies/${companyID}/PurchaseOrderSettings/${this.currentVendor.vendorCode}`
        );
        this.currentVendor.logo = uploadLogo.imageUrl;
        await vendorRef.update({
          logo: this.currentVendor.logo,
        });
      } catch (error) {
        console.log(error);
        this.snackbarSaveError = true;
      }
    },
    async uploadVendorLogo(file, vendorCode) {
      try {
        if (!file) return;
        const isTooSmall = await checkImageSmall(file, 50);
        if (isTooSmall) {
          this.snackbarImageTooSmall = true;
          return;
        }
        if (this.isImageTooLarge(file)) {
          this.snackbarImageTooLarge = true;
          return;
        }
        const companyID = this.$route.params.companyId;
        const uploadLogo = await uploadToCurrentUserCompanyBucket(
          file,
          companyID,
          `Logo/${vendorCode}`
        );
        return uploadLogo.imageUrl;
      } catch (error) {
        console.log(error);
        this.snackbarSaveError = true;
      }
    },
    isImageTooLarge(img, max = 4096) {
      return img.size / 1024 >= max;
    },
    async deleteVendorLogos(userID, companyID, vendorCode) {
      const ref = `Users/${userID}/Companies/${companyID}/Logo/${vendorCode}/`;
      const logosRef = fc.storage.ref(ref);
      const logosRefList = await logosRef.listAll();
      for (const item of logosRefList.items) {
        try {
          await item.delete();
        } catch (e) {
          console.error(e);
        }
      }
    },
    async deleteVendorBranch() {
      const index = this.deleteBranchData.index;
      if (this.currentVendorBranches[index]) {
        this.currentVendorBranches.splice(index, 1);
      } else {
        this.snackbarSaveError = true;
        return;
      }
      const companyID = this.$route.params.companyId;
      const vendorID = this.currentVendor.vendorCode;
      const vendorRef = fc.companies.doc(
        `${companyID}/PurchaseOrderSettings/${vendorID}`
      );
      if ((await vendorRef.get()).exists) {
        vendorRef.update({
          branches: this.currentVendorBranches,
        });
        this.snackbarDelete = true;
      } else {
        this.snackbarSaveError = true;
      }
      this.isShowDeleteBranchDialog = false;
    },
    async addNewVendorBranch() {
      this.isAddingBranch = true;
      const companyID = this.$route.params.companyId;
      const vendorID = this.currentVendor.vendorCode;
      const vendorRef = fc.companies.doc(
        `${companyID}/PurchaseOrderSettings/${vendorID}`
      );
      if ((await vendorRef.get()).exists) {
        this.currentVendorBranches.push({ ...this.addBranchData });
        vendorRef.update({
          branches: this.currentVendorBranches,
        });
        this.snackbar = true;
        this.isShowAddBranchDialog = false;
      } else {
        this.snackbarSaveError = true;
      }
      this.isAddingBranch = false;
    },
    mustNotContainBlank(obj) {
      return Object.values(obj).every((value) => value !== "");
    },
    openDeleteBranchDialog(index) {
      this.deleteBranchData = { index, ...this.currentVendorBranches[index] };
      this.isShowDeleteBranchDialog = true;
    },
  },

  watch: {
    currentSelectedOcrService(newVal) {
      this.currentVendor.isPython = newVal;
    },
    primaryModelIndex(newVal) {
      this.currentVendor.vendorOpenAiModel1 = newVal;
    },
    secondaryModelIndex(newVal) {
      this.currentVendor.vendorOpenAiModel2 = newVal;
    },
    searchKeywordsDsp(val) {
      this.currentVendor.searchKeywords = val?.split("||") || [];
    },
    specialSearchKeywordsDsp(val) {
      this.currentVendor.specialSearchKeywords = val?.split("||") || [];
    },
    currentTabIndex(val) {
      if (this.selectedCompanyAutoDocConfig.length > 0) {
        this.searchKeywordsDsp =
          this.selectedCompanyAutoDocConfig[val].searchKeywords?.join("||");
        this.specialSearchKeywordsDsp =
          this.selectedCompanyAutoDocConfig[val].specialSearchKeywords?.join(
            "||"
          );
        this.currentVendor = Object.assign(
          {},
          this.selectedCompanyAutoDocConfig[val]
        );
        // Ensure isPython is initialized
        this.currentVendor.isPython = this.currentVendor.isPython ?? false;
        this.currentVendorCopy = Object.assign({}, this.currentVendor);

        // Update model indices when tab changes
        this.primaryModelIndex =
          this.currentVendor.vendorOpenAiModel1 || this.modelOptions[0].value;
        this.secondaryModelIndex =
          this.currentVendor.vendorOpenAiModel2 || this.modelOptions[1].value;

        // Update OCR service based on currentVendor
        this.currentSelectedOcrService = this.currentVendor.isPython || false;

        this.isEditPrompt = false;
        this.currentVendorModelTab = 0;
      }
    },
    selectedCompanyAutoDocConfig(val) {
      if (val && val.length > 0) {
        this.searchKeywordsDsp =
          val[this.currentTabIndex].searchKeywords?.join("||");
        this.specialSearchKeywordsDsp =
          val[this.currentTabIndex].specialSearchKeywords?.join("||");
        this.currentVendor = Object.assign({}, val[this.currentTabIndex]);
        // Ensure isPython is initialized
        this.currentVendor.isPython = this.currentVendor.isPython ?? false;
        this.currentVendorCopy = Object.assign({}, this.currentVendor);

        // Initialize model indices based on currentVendor
        this.primaryModelIndex =
          this.currentVendor.vendorOpenAiModel1 || this.modelOptions[0].value;
        this.secondaryModelIndex =
          this.currentVendor.vendorOpenAiModel2 || this.modelOptions[1].value;

        // Initialize OCR service based on currentVendor
        this.currentSelectedOcrService = this.currentVendor.isPython || false;

        this.isEditPrompt = false;
      }
    },
    isShowBranchDialog(val) {
      if (!val) {
        this.isEditVendorBranch = false;
      }
      this.currentVendorBranches =
        this.currentVendor.branches?.map((item) => ({ ...item })) || [];
    },
    isShowAddBranchDialog(val) {
      if (!val) {
        this.addBranchData = {
          branchName: "",
          branch: "",
          district: "",
          subDistrict: "",
          province: "",
          street: "",
          zipCode: "",
        };
      }
    },
    selectedCompany(val) {
      this.currentSelectedCompany = Object.assign(
        {},
        {
          openAiKey: val.openAiKey,
        }
      );
      this.currentSelectedCompanyCopy = Object.assign(
        {},
        {
          openAiKey: val.openAiKey,
        }
      );
    },
    selectedMonth(newVal, oldVal) {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getDateListChatGptActivityLog", {
        companyId,
        newVal,
      });
      this.modelData = this.findModelData(newVal);
    },
    selectedChatGptActivityLog(newVal, oldVal) {
      this.modelData = this.findModelData(this.selectedMonth);
    },
    //  expanded(newVal, oldVal) {
    //   // Optional: Handle changes to the expanded state
    //   if(newVal.length !== 0){
    //     this.historyDateDetails = {}
    //    // console.log('month :', this.selectedMonth);
    //    // console.log('day :', newVal[0].id);
    //     let  month = this.selectedMonth || ''
    //     let  day = newVal[0].id || ''
    //     let companyId = this.$route.params.companyId;
    //     this.$store.dispatch("companies/getDateDetailChatGptActivityLog", {
    //     companyId,
    //     month,
    //     day,
    //      })
    //   }else{
    //    // console.log('row not expanded');
    //   }
    // }
  },
};
</script>
<style lang="scss" scoped>
.row-wrapper {
  padding-left: 20px;
}

.nowrap th,
td {
  white-space: nowrap;
}

.expanded-item-td {
  padding: 0;
}

.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: 0 0 0 0 !important;
}

.my-header-style {
  background: rgba(59, 130, 246, 0.5);
}

.row_Class {
  background-color: rgba(0, 0, 0, 0.12);
}

.vendor-avatar {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.img-show {
  width: 6rem;
  height: 6rem;
  object-fit: contain;
}
:deep(.el-tabs__item) {
  font-size: 16px !important;
}

:deep(.el-tabs__item.is-active) {
  color: #6ec39b !important;
  font-weight: 600 !important;
}

:deep(.el-tabs__item:hover) {
  color: #6ec39b90 !important;
  font-weight: 600 !important;
}

:deep(.el-tabs__active-bar) {
  background-color: #6ec39b !important;
}

.model_wrapper {
  background-color: #f0f0f025;
  border: 1px solid #b6b6b653;
}

.disabled-chip-group {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
